<ng-container *ngIf="checkboxes$ | async as checkboxes">
  <div class="ds-info mb-3" *ngIf="checkboxes.length === 0 && isDesignMode">
    {{ infoText }}
  </div>

  <fieldset *ngIf="checkboxes.length || isDesignMode">
    <legend i18n="@@headline.checkbox_please_confirm">Bitte bestätigen Sie </legend>
    <orderform-inputs-generator
      #fieldInput
      (dataChanges)="setData($event)"
      [disableDataFromBackend]="true"
      [data]="filledCheckboxes$ | async"
      [fields]="checkboxes"
      [attr.data-e2e]="'form:checkboxes'"
    ></orderform-inputs-generator>
  </fieldset>
</ng-container>
